import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Per-device memory for the desktop rail (DS04): at 1280px and up it shows
 * its labels unless the person collapsed it to icons. A per-viewer
 * convenience, so browser storage is enough.
 */
interface NavState {
  collapsed: boolean;
  toggleCollapsed: () => void;
  /** Menu folders the person opened or closed by hand (key → open). */
  folders: Record<string, boolean>;
  setFolder: (key: string, open: boolean) => void;
}

export const useNavStore = create<NavState>()(
  persist(
    (set) => ({
      collapsed: false,
      toggleCollapsed: () => set((s) => ({ collapsed: !s.collapsed })),
      folders: {},
      setFolder: (key, open) => set((s) => ({ folders: { ...s.folders, [key]: open } })),
    }),
    { name: 'unipostudio.nav' },
  ),
);
